export const TYPES = {
  PUBLICATIONS: 'FILTERS_TYPES_PUBLICATIONS',
  RELEASES: 'FILTERS_TYPES_RELEASES',
};
